import { useCallback, useState } from 'react'
import { startOfMonth, startOfWeek, subDays } from 'date-fns'

import { DashboardPeriod } from '../../../domain/dashboard.types'
import { DASHBOARD_PERIOD } from '../../../domain/enums/dashboard.enum'
import { TIME_INTERVALS } from '../../../domain/enums/timeInterval.enum'

export const useTimeData = () => {
  const [selectedDate, setSelectedDate] = useState<number>(subDays(Date.now(), 1).valueOf())
  const [periodSelected, setPeriodSelected] = useState<DashboardPeriod>(DASHBOARD_PERIOD.DAY)
  const [optionsDatePicker, setOptionsDatePicker] = useState<any>()
  const [interval, setInterval] = useState(TIME_INTERVALS.ONE_HOUR)

  const intervalSetter = useCallback((intervalType: DashboardPeriod) => {
    switch (intervalType) {
      case DASHBOARD_PERIOD.DAY:
        setInterval(TIME_INTERVALS.ONE_HOUR)
        break
      case DASHBOARD_PERIOD.WEEK: {
        setInterval(TIME_INTERVALS.ONE_DAY)
        break
      }
      case DASHBOARD_PERIOD.MONTH:
        setInterval(TIME_INTERVALS.ONE_DAY)
        break
      case DASHBOARD_PERIOD.YEAR:
        setInterval(TIME_INTERVALS.ONE_MONTH)
        break
      default:
        setInterval(TIME_INTERVALS.ONE_DAY)
        break
    }
  }, [])

  const datePickerParamsBuilder = useCallback(
    (intervalType: DashboardPeriod) => {
      switch (intervalType) {
        case DASHBOARD_PERIOD.DAY:
          return {
            dateFormat: 'dd/MM/yyyy',
            maxDate: subDays(new Date(), 1), // Set the maximum date to yesterday
          }
        case DASHBOARD_PERIOD.WEEK:
          return {
            dateFormat: "'semaine' w, yyyy",
            showWeekNumber: true,
            maxDate: startOfWeek(new Date()),
          }
        case DASHBOARD_PERIOD.MONTH:
          return {
            dateFormat: 'MMMM yyyy',
            showMonthYearPicker: true,
            maxDate: startOfMonth(new Date()),
          }
        case DASHBOARD_PERIOD.YEAR:
          return {
            dateFormat: 'yyyy',
            showYearPicker: true,
            maxDate: new Date(), // Set the maximum date to current year
          }
        default:
          return {}
      }
    },
    [periodSelected]
  )

  return {
    interval,
    selectedDate,
    periodSelected,
    optionsDatePicker,
    setSelectedDate,
    setPeriodSelected,
    setOptionsDatePicker,
    setInterval,
    datePickerParamsBuilder,
    intervalSetter,
  }
}
